import { render, staticRenderFns } from "./AllCustomer.vue?vue&type=template&id=dc2857c4&"
import script from "./AllCustomer.vue?vue&type=script&lang=js&"
export * from "./AllCustomer.vue?vue&type=script&lang=js&"
import style0 from "./AllCustomer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports